<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title
        h1.subheading Task Completed By Day
    div#30daySale(style="width: 100%; height: 300px; margin: 0 auto")
</template>

<script>
import taskService from "../../Tasks/service";

export default {
  mounted() {
    this.compliteByDay();
  },
  methods: {
    compliteByDay() {
      return taskService.compliteByDay().then(data => {
        if (data) {
          let days = [];
          data.data.map(row => {
            days.push({ name: row.day, y: row.count });
          });
          Highcharts.chart("30daySale", {
            credits: false,
            title: {
              text: null
            },
            legend: {
              enabled: true
            },
            chart: {
              type: "areaspline"
            },
            xAxis: {
              type: "category"
            },
            yAxis: {
              title: {
                text: null
              }
            },
            legend: {
              enabled: false
            },
            plotOptions: {
              series: {
                borderWidth: 0,
                dataLabels: {
                  enabled: true,
                  format: "{point.y:.1f}%"
                }
              }
            },

            tooltip: {
              headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
              pointFormat:
                '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>'
            },
            series: [
              {
                name: "Days",
                data: days
              }
            ]
          });
        }
      });
    }
  }
};
</script>
